import { render, staticRenderFns } from "./cadastro-usuario.html?vue&type=template&id=2b39e6e3&scoped=true&"
import script from "./cadastro-usuario.js?vue&type=script&lang=js&"
export * from "./cadastro-usuario.js?vue&type=script&lang=js&"
import style0 from "./cadastro-usuario.css?vue&type=style&index=0&id=2b39e6e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b39e6e3",
  null
  
)

export default component.exports